var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6.5,
    width: 115,
    height: 115,
    rx: 15.1,
    style: {
      fill: "#fff",
      stroke: "#999",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8,56.6V28.2c0-1.5.1-2.9.2-4.3.6-5.3,3.7-8.8,8.9-8.9,13.4-.1,26.9-.5,40.2.4,17.5,1.3,28.1,12.1,33.2,28.2a70.8,70.8,0,0,1-.1,42.5c-5.1,17.1-17.6,27.1-36.1,28.2-12.1.7-24.3.3-36.4.1-5.9-.1-8.6-2.9-9.6-8.7-.2-1.5-.3-3.1-.4-4.6s.8-2.4,2.4-2.5,4.5.1,6.7,0c10.8-.1,21.6-.1,32.4-.3s16.9-5.4,20.3-14.7a56.5,56.5,0,0,0,.6-37C80.9,36.2,72.9,31.7,62.5,31.2c-6.5-.3-12.9-.3-19.4-.3-.3,0-.9.9-.9,1.3,0,18.1,0,36.1.1,54.1,0,4.2-1.4,5.6-5.6,5.6H26.6c-3.3,0-4.9-1.6-4.9-4.9V56.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55,50.1c.9,0,5.9.1,7.7,2.1S64.2,59,64.2,59h3.7a11,11,0,0,0-2.8-8.9C61.8,46.6,55,47,55,47Z",
    style: {
      fill: "#c1272d",
      stroke: "#c1272d",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,37s12-.9,17.9,5.5S77.8,59,77.8,59H74.2s1-8.2-3.6-12.8c-6.4-6.4-14-5.5-15.6-5.5Z",
    style: {
      fill: "#c1272d",
      stroke: "#c1272d",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.045b7f5ce532d0c513bfbe9fc552ff32.svg";
export { ForwardRef as ReactComponent };